module.exports = __webpack_public_path__ + "img/-LV56Eo7Y1UIMbn7vNRW.fba4395e.jpg";